import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { storage } from "../../utils";
import utils from "../../components/toastify/toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { BlogImageUploadPlugin } from "../../utils/blogImageUpload";
import moment from "jalali-moment";
import DatePicker from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";

const FormData = require("form-data");

const selectedDayFromDate = (value = new Date()) => ({
  year: Number(moment(value).locale("fa").format("YYYY")),
  month: Number(moment(value).locale("fa").format("M")),
  day: Number(moment(value).locale("fa").format("D")),
});

const publicationIso = (day, time) =>
  moment(
    `${day.year}/${String(day.month).padStart(2, "0")}/${String(day.day).padStart(2, "0")} ${time}`,
    "jYYYY/jMM/jDD HH:mm"
  ).toISOString();

const EditBlogPost = () => {
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [short_title, set_short_title] = useState("");
  const [news_summary, set_news_summary] = useState("");
  const [description, set_description] = useState("");
  const [slug, set_slug] = useState("");
  const [content_img, set_content_img] = useState(null);
  const [published, set_published] = useState(true);
  const [category_id, set_category_id] = useState("");
  const [categories, set_categories] = useState([]);
  const [publishedDay, setPublishedDay] = useState(() => selectedDayFromDate());
  const [publishedTime, setPublishedTime] = useState(() => moment().format("HH:mm"));
  let history = useHistory();

  useEffect(() => {
    storage.load("token").then((tok) => {
      if (!tok) return;
      Axios.get("/get_blog_post/" + id, { headers: { "x-auth": tok } })
        .then(({ data }) => {
          const p = data?.data;
          setTitle(p?.title || "");
          set_short_title(p?.short_title || "");
          set_news_summary(p?.news_summary || "");
          set_description(p?.description || "");
          set_slug(p?.slug || "");
          set_published(p?.published !== false);
          set_category_id(p?.category_id?._id || p?.category_id || "");
          const publishedAt = p?.published_at || p?.creation_date || new Date();
          setPublishedDay(selectedDayFromDate(publishedAt));
          setPublishedTime(moment(publishedAt).format("HH:mm"));
        })
        .catch(() => {});
    });
  }, [id]);

  useEffect(() => {
    storage.load("token").then((tok) => {
      if (!tok) return;
      Axios.get("/get_blog_categories", { headers: { "x-auth": tok } })
        .then(({ data }) => set_categories(data?.data || []))
        .catch(() => {});
    });
  }, []);

  const sendData = () => {
    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',
      overlayCSS: { backgroundColor: $white, opacity: 0.8, cursor: "wait" },
      css: { border: 0, padding: 0, backgroundColor: "transparent" },
    });

    const formData = new FormData();
    formData.append("id", id);
    formData.append("title", title);
    formData.append("short_title", short_title);
    formData.append("news_summary", news_summary);
    formData.append("description", description);
    formData.append("slug", slug);
    formData.append("published", published);
    formData.append("published_at", publicationIso(publishedDay, publishedTime));
    formData.append("category_id", category_id);
    if (content_img) formData.append("logo_img", content_img);

    storage.load("token").then((res) => {
      if (!res) return Promise.reject();
      Axios.post("/edit_blog_post", formData, {
        headers: { "x-auth": res, "Content-Type": "multipart/form-data" },
      })
        .then(() => {
          $.unblockUI();
          history.push("/dashboard/getBlogPosts");
        })
        .catch(() => {
          utils.showAlert("خطایی به وجود آمده است", "error");
          $.unblockUI();
        });
    });
  };

  return (
    <div className="AddProductContainer">
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">ویرایش پست</h4>
              </div>
              <div class="card-content">
                <div class="card-body">
                  <div class="row justify-content-between" style={{ minWidth: "100%" }}>
                    <div class="col-md-6 col-12 form-group d-flex align-items-center w-100" style={{ minWidth: "100%" }}>
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <h6>تیتر</h6>
                        <input type="text" class="form-control" placeholder="تیتر" value={title} onChange={(e) => setTitle(e.target.value)} />
                        <h6 style={{ marginTop: 10 }}>رو تیتر</h6>
                        <input type="text" class="form-control" placeholder="رو تیتر" value={short_title} onChange={(e) => set_short_title(e.target.value)} />
                        <h6 style={{ marginTop: 10 }}>خلاصه خبر</h6>
                        <textarea className="form-control" rows={3} maxLength={500} placeholder="خلاصه کوتاه خبر که زیر تصویر نمایش داده می‌شود" value={news_summary} onChange={(e) => set_news_summary(e.target.value)} />
                        <h6 style={{ marginTop: 10 }}>اسلاگ</h6>
                        <input type="text" class="form-control" value={slug} onChange={(e) => set_slug(e.target.value)} />
                        <h6 style={{ marginTop: 10 }}>دسته‌بندی</h6>
                        <select className="form-control" value={category_id} onChange={(e) => set_category_id(e.target.value)}>
                          <option value="">بدون دسته‌بندی</option>
                          {categories.map((category) => <option key={category._id} value={category._id}>{category.name}</option>)}
                        </select>
                        <h6 style={{ marginTop: 10 }}>تاریخ و ساعت انتشار</h6>
                        <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
                          <DatePicker
                            value={publishedDay}
                            onChange={setPublishedDay}
                            inputPlaceholder="انتخاب تاریخ انتشار"
                            shouldHighlightWeekends
                            locale="fa"
                          />
                          <input
                            type="time"
                            className="form-control"
                            style={{ maxWidth: "150px" }}
                            value={publishedTime}
                            onChange={(event) => setPublishedTime(event.target.value)}
                            aria-label="ساعت انتشار"
                          />
                        </div>
                        <h6 style={{ marginTop: 10 }}>توضیحات پست</h6>
                        <CKEditor
                          onReady={(editor) => {
                            editor.ui
                              .getEditableElement()
                              .parentElement.insertBefore(
                                editor.ui.view.toolbar.element,
                                editor.ui.getEditableElement()
                              );
                          }}
                          editor={DecoupledEditor}
                          data={description}
                          config={{ language: "fa", extraPlugins: [BlogImageUploadPlugin] }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            set_description(data);
                          }}
                        />
                        <div class="mt-1">
                          <input type="checkbox" id="published" checked={published} onChange={(e) => set_published(e.target.checked)} />
                          <label htmlFor="published" className="ml-1">منتشر شود</label>
                        </div>
                        <div class="row mt-1">
                          <div class="col-md-6">
                            <fieldset>
                              <h6>آپلود تصویر</h6>
                              <div class="input-group">
                                <div class="custom-file">
                                  <input type="file" class="custom-file-input" id="inputGroupFile02" onChange={(e) => set_content_img(e.target.files[0])} />
                                  <label class="custom-file-label" htmlFor="inputGroupFile02">
                                    {content_img ? content_img.name : "انتخاب فایل"}
                                  </label>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        </div>

                        <button onClick={sendData} class="btn btn-success mr-1 mb-1 mt-2">ذخیره تغییرات</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export { EditBlogPost };


